import { Navigate } from "react-router-dom"
import useUser from "../hooks/useUser"
import { usePublicSiteId } from "../contexts/PublicSiteContext"
import { isConstructionWalk } from "../utils/publicSite"
import { isCompanyAdmin } from "../utils/companyAccess"

/** ConstructionWalk companies page: refuse non-admins (not only hide the nav link). */
export default function ConstructionAdminRoute({ children }: { children: JSX.Element }) {
  const siteId = usePublicSiteId()
  const { roleId } = useUser()

  if (isConstructionWalk(siteId) && !isCompanyAdmin(roleId)) {
    return <Navigate to="/app" replace />
  }

  return children
}
